// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogDuplicationForm from "./CatalogDuplicationForm.res.js";

function CatalogDuplicationFormSourceCard(props) {
  let duplicationMode = props.duplicationMode;
  let references = props.references;
  let availableShops = props.shopsData.filter(shop => shop.duplicability === "ExistsAlready");
  let options = availableShops.map(shop => {
    let reference = references.find(param => param.shopId === shop.dataId);
    if (duplicationMode === "Product") {
      if (reference !== undefined) {
        return {
          TAG: "Product",
          _0: {
            id: reference.id,
            shopId: reference.shopId
          }
        };
      } else {
        return;
      }
    } else if (reference !== undefined) {
      return {
        TAG: "Variant",
        _0: {
          id: reference.id,
          shopId: reference.shopId
        }
      };
    } else {
      return;
    }
  });
  let optionToLabel = source => Stdlib_Option.mapOr(Stdlib_Option.flatMap(source, source => availableShops.find(shop => {
    let match = shop.dataId;
    let id = source._0.shopId;
    if (id !== undefined) {
      return match === id;
    } else {
      return false;
    }
  })), "", param => param.dataName);
  let items = options.map(source => ({
    TAG: "Option",
    key: optionToLabel(source),
    label: optionToLabel(source),
    value: source
  }));
  let sections = [{
      items: items
    }];
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(CatalogDuplicationForm.InputSelect.make, {
      field: "Source",
      label: I18n.t("Shop catalog"),
      placeholder: I18n.t("Select a shop"),
      sections: sections
    }),
    grow: true
  });
}

let make = React.memo(CatalogDuplicationFormSourceCard);

export {
  make,
}
/* make Not a pure module */
